export default __webpack_public_path__ + "static/media/menuDivider.b7abf7ce.svg";